import { render, staticRenderFns } from "./BaseSelectWithProvider.vue?vue&type=template&id=8018e208&scoped=true&"
import script from "./BaseSelectWithProvider.vue?vue&type=script&lang=js&"
export * from "./BaseSelectWithProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018e208",
  null
  
)

export default component.exports